import { render, staticRenderFns } from "./personalizacao-paleta.vue?vue&type=template&id=34b5a642&scoped=true&"
import script from "./personalizacao-paleta.vue?vue&type=script&lang=js&"
export * from "./personalizacao-paleta.vue?vue&type=script&lang=js&"
import style0 from "./personalizacao-paleta.vue?vue&type=style&index=0&id=34b5a642&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5a642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b5a642')) {
      api.createRecord('34b5a642', component.options)
    } else {
      api.reload('34b5a642', component.options)
    }
    module.hot.accept("./personalizacao-paleta.vue?vue&type=template&id=34b5a642&scoped=true&", function () {
      api.rerender('34b5a642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/personalizacao-painel/personalizacao-paleta.vue"
export default component.exports